// extracted by mini-css-extract-plugin
export default {"profileGroup":"profileInfo_profileGroup__NGF1y","info":"profileInfo_info__7geFk","infoName":"profileInfo_infoName__AQ43X","infoDesc":"profileInfo_infoDesc__-DAOg"};